<template>
  <div
    :class="[
      !parentType ? 'grid-container' : '',
      options.buttonType === 'floating' && !isEditing
        ? 'px-10 pb-0 w-fit mt-0 fixed right-10 bottom-10 container mx-auto z-50'
        : '',
    ]"
  >
    <div
      class="my-5 last:mb-0"
      :class="[
        !parentType && options.buttonType !== 'floating'
          ? 'col-span-4 last:mb-5 sm:col-span-6 md:col-span-6 md:col-start-2 lg:col-span-8 lg:col-start-3'
          : '',
        !parentType && options.buttonType === 'floating' && !isEditing
          ? 'px-0 md:px-10 pb-0 w-fit mt-0 fixed right-5 md:right-10 bottom-10 container mx-auto'
          : '',
        !parentType && options.buttonType === 'floating' && isEditing
          ? 'relative container mx-auto'
          : '',
      ]"
    >
      <VuepalLink
        :to="link?.uri?.path"
        :class="[!isEditing ? buttonFloatingClassList : '', buttonClassList]"
      >
        {{ label }}

        <SpriteSymbol name="arrow-right" class="size-6" />
      </VuepalLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphButtonFragment } from '#graphql-operations'

defineProps<{
  label: ParagraphButtonFragment['label']
  link: ParagraphButtonFragment['link']
}>()

const { options, parentType, isEditing } = defineBlokkli({
  bundle: 'button',
  editor: {
    editTitle: (el) => el.textContent,
  },
  options: {
    buttonType: {
      type: 'radios',
      label: 'Button Type',
      default: 'standard',
      options: {
        standard: 'Default',
        filled: 'Filled',
        textOnly: 'Text only',
        floating: 'Floating',
      },
    },
  },
})

const buttonClassList = computed(() => {
  const classList = ['button']

  if (options.value.buttonType === 'filled') {
    classList.push('is-filled')
  }

  if (options.value.buttonType === 'textOnly') {
    classList.push('is-text-only')
  }

  if (options.value.buttonType === 'floating') {
    classList.push('is-filled')
  }

  return classList
})

const buttonFloatingClassList = computed(() => {
  const classList = []

  if (options.value.buttonType === 'floating') {
    classList.push('is-floating')
  }

  return classList
})
</script>
